/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_EXPENSES_LIST_RECORDS_META_DATA,
  LOAD_EXPENSES_LIST,
  CREATE_EXPENSES_LIST,
  UPDATE_EXPENSES_LIST,
  DELETE_EXPENSES_LIST,
  LOAD_EXPENSES_ITEMS_LIST,
  LOAD_EXPENSES_CATEGORIES_LIST,
  LOAD_EXPENSE_REPORT_LIST,
  LOAD_CASH_BANK_REPORT_LIST,
  LOAD_PREFIX_SETTINGS_LIST,
  LOAD_FINANCIAL_YEAR_LIST,
  LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS,
} from "./constants";

import {
  loadExpensesItemList,
  loadExpensesItemListSuccess,
  loadExpensesItemListError,
  createExpensesListSuccess,
  createExpensesListError,
  updateExpensesListSuccess,
  updateExpensesListError,
  deleteExpensesListSuccess,
  deleteExpensesListError,
  loadExpensesListRecordsMetaDataError,
  loadExpensesListRecordsMetaDataSuccess,
  loadExpensesList,
  loadExpensesListSuccess,
  loadExpensesListError,
  loadExpensesCategories,
  loadExpensesCategoriesSuccess,
  loadExpensesCategoriesError,
  loadAccountTransactionList,
  loadAccountTransactionListSuccess,
  loadAccountTransactionListError,
  loadExpensesReportList,
  loadExpensesReportListSuccess,
  loadExpensesReportListError,
  loadCashBankReportList,
  loadCashBankReportListSuccess,
  loadCashBankReportListError,
  loadPrefixSettingsList,
  loadPrefixSettingsListSuccess,
  loadPrefixSettingsListError,
  loadFinancialYearList,
  loadFinancialYearListSuccess,
  loadFinancialYearListError,
} from "./actions";

import {
  loadExpensesDetails,
  createExpensesDetails,
  updateExpensesDetails,
  deleteExpensesDetails,
  loadRecordsMetaData,
  loadExpensesItemDetails,
  loadAccountTransactionDetails,
  // loadCashInHandDetails,
  loadExpensesCategoriesDetails,
  loadExpensesReportDetails,
  loadCashBankReportDetails,
  loadPrefixSettingsDetails,
  loadFinancialYearDetails,
} from "./remotes";

function* loadExpensesListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EXPENSES_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadExpensesList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadExpensesDetails, paymentDetails);

        if (result) {
          yield put(loadExpensesListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadExpensesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPrefixSettingsListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PREFIX_SETTINGS_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadPrefixSettingsList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPrefixSettingsDetails, paymentDetails);

        if (result) {
          yield put(loadPrefixSettingsListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPrefixSettingsListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
//financial year
function* loadFinancialYearListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_FINANCIAL_YEAR_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadFinancialYearList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFinancialYearDetails, paymentDetails);

        if (result) {
          yield put(loadFinancialYearListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadFinancialYearListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadExpensesReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EXPENSE_REPORT_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadExpensesReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadExpensesReportDetails, paymentDetails);

        if (result) {
          yield put(loadExpensesReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadExpensesReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCashBankReportSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CASH_BANK_REPORT_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadCashBankReportList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCashBankReportDetails, paymentDetails);

        if (result) {
          yield put(loadCashBankReportListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCashBankReportListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAccountTransactionListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EXPENSE_ACCOUNT_TRANSACTION_DETAILS),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadAccountTransactionList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadAccountTransactionDetails,
          paymentDetails
        );

        if (result) {
          yield put(loadAccountTransactionListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAccountTransactionListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadExpensesItemDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EXPENSES_ITEMS_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadExpensesItemList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadExpensesItemDetails, paymentDetails);

        if (result) {
          yield put(loadExpensesItemListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadExpensesItemListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadExpensesCategoriesSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EXPENSES_CATEGORIES_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadExpensesCategories(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadExpensesCategoriesDetails,
          paymentDetails
        );

        if (result) {
          yield put(loadExpensesCategoriesSuccess(result));
        }
      } catch (error) {
        yield put(
          loadExpensesCategoriesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_EXPENSES_LIST),
    });

    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(createExpensesDetails, paymentDetails);
        if (result) {
          yield put(createExpensesListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createExpensesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePaymentSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_EXPENSES_LIST),
    });
    const { paymentDetails } = update || {};

    if (update) {
      try {
        const result = yield call(updateExpensesDetails, paymentDetails);
        if (result) {
          yield put(updateExpensesListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updateExpensesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_EXPENSES_LIST),
    });
    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(deleteExpensesDetails, paymentDetails);
        if (result) {
          yield put(deleteExpensesListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deleteExpensesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadExpensesDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_EXPENSES_LIST_RECORDS_META_DATA),
    });

    try {
      const paymentMode = yield call(
        loadRecordsMetaData,
        "getpaymentmode",
        "post"
      );

      let recordsMetaData = {
        paymentModeOptions:
          (paymentMode &&
            paymentMode &&
            paymentMode.length > 0 &&
            paymentMode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.paymentModeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadExpensesListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadExpensesListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadExpensesListSaga(),
    loadPrefixSettingsListSaga(),
    loadFinancialYearListSaga(),
    loadExpensesReportSaga(),
    loadCashBankReportSaga(),
    deletePaymentSaga(),
    updatePaymentSaga(),
    createPaymentSaga(),
    loadExpensesItemDetailsSaga(),
    loadExpensesCategoriesSaga(),
    loadExpensesDetailsMetaDataSaga(),
    loadAccountTransactionListSaga(),
  ]);
}
